import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from '@/components/ui/table'
import type { DataTableSkeletonProps } from './types'

const DEFAULT_SKELETON_ROWS = 5

export function DataTableSkeleton({
  columnCount,
  rowCount = DEFAULT_SKELETON_ROWS,
}: DataTableSkeletonProps) {
  const rows = Array.from({ length: rowCount }, (_, i) => i)
  const cells = Array.from({ length: columnCount }, (_, i) => i)

  return (
    <div
      className="rounded-lg border border-v11-border bg-v11-surface"
      data-testid="data-table-skeleton"
    >
      <Table>
        <TableHeader>
          <TableRow>
            {cells.map((cellIndex) => (
              <TableHead key={cellIndex}>
                <Skeleton className="h-4 w-24" />
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((rowIndex) => (
            <TableRow key={rowIndex} data-testid="skeleton-row">
              {cells.map((cellIndex) => (
                <TableCell key={cellIndex} data-testid="skeleton-cell">
                  <Skeleton className="h-4 w-full" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
